import { Badge } from '@optiaxiom/react';

const getStatusBadgeIntent = (status: string) => {
  switch (status.toLowerCase()) {
    case 'completed':
      return 'success';
    case 'failed':
      return 'danger';
    case 'running':
    case 'pending':
      return 'warning';
    default:
      return 'neutral';
  }
};

export const StatusCell = ({ status }: { status: string }) => {
  return (
    <Badge intent={getStatusBadgeIntent(status)}>
      {status.toLowerCase() === 'pending'
        ? 'Running'
        : status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()}
    </Badge>
  );
};
